module.exports = "<p>\n  addressedit works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/addressedit/addressedit.component.html
// module id = ./src/app/addressedit/addressedit.component.html
// module chunks = main